import { ComboField } from '@components/Fields/ComboField';
import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { MenuItem } from '@material-ui/core';
import { EnumEmpresa, IComboEmpresa } from '@model/Empresa';
import { IComboFormaPagamento } from '@model/FormaPagamento';
import { IComboRemetenteWhatsapp } from '@model/RemetenteWhatsapp';
import { IComboUsuario } from '@model/Usuario';
import { IPagamentoFilter } from '@services/RelatorioService';
import React from 'react';

export type PagamentoFilterProps = {
    filter: IFilter<IPagamentoFilter>
    isLoading: boolean
    empresaCombo: IComboEmpresa
    formaPagamentoCombo: IComboFormaPagamento
    usuarioCombo: IComboUsuario
    remetenteWhatsappCombo: IComboRemetenteWhatsapp
}

export function PagamentoFilter ({ filter, isLoading, empresaCombo, formaPagamentoCombo, usuarioCombo, remetenteWhatsappCombo }: PagamentoFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competenciaPagamento}
                        label="Competência Pagamento"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        required
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competenciaReferencia}
                        label="Competência Referência"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumEmpresa.None}>Todas</MenuItem>
                        {
                            empresaCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={3}>
                    <ComboField
                        field={filter.fields.formasPagamento}
                        label="Formas Pagamento"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        SelectProps={{
                            multiple: true
                        }}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        {
                            formaPagamentoCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={3}>
                    <ComboField
                        field={filter.fields.remetenteWhatsapp}
                        label="Remetente"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        {
                            remetenteWhatsappCombo.createOptionsWithNumero()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.usuarioId}
                        label="Usuário"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key="t" value={0}>Todos</MenuItem>
                        {
                            usuarioCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}